// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VZP-","badges":"styles_badges__Sea9Q"};